import { render, staticRenderFns } from "./LocationReportSyn.vue?vue&type=template&id=70c3d8e5&"
import script from "./LocationReportSyn.vue?vue&type=script&lang=js&"
export * from "./LocationReportSyn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports